import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'search',
  standalone: true,
})
export class SearchPipe implements PipeTransform {
  transform(value: any[], searchTerm: string): any[] {
    if (!value) return [];
    if (!value.length) return [];
    if (!searchTerm) return value;
    return value.filter((v) => JSON.stringify(v).toLowerCase().includes(searchTerm.toLocaleLowerCase()));
  }
}
